import React, { useState } from 'react';
import Search from '../../Components/Search';
import SearchForm from '../Customers/SearchForm';
import Modal from '../../Components/Modal';
import Button from '../../Components/Button/Button';
import Title from '../../Components/Formatting/Customer/Title';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import Dropdown from '../../Components/Dropdown';
import RecipientStatus from './RecipientStatus';
import ButtonRow from '../../Components/Button/ButtonRow';
import NoItems from '../../Components/EmptyStates/NoItems';
import { getEntityLink } from '../../Services/helpers';

const Customers = ({broadcast, selectRecipients}) => {
    const [selectCustomers, setSelectingCustomers] = useState(false);

    return <>
        <UpdateConditions {...{broadcast, selectRecipients, selectCustomers, setSelectingCustomers}} />
        <Recipients {...{broadcast, selectCustomers, setSelectingCustomers}} />
    </>
}

const UpdateConditions = ({broadcast, selectRecipients, selectCustomers, setSelectingCustomers}) => {


    return <Search>
        <Modal title="Update conditions" isOpen={selectCustomers} setIsOpen={setSelectingCustomers}>
            <SearchForm submitLabel="Update"
                data={broadcast.customerQueryOptions}
                updateSearch={selectRecipients}
                cancel
            />
        </Modal>
        <ButtonRow arrange="right">
            <Button
                theme="primary"
                label="Select customers"
                onClick={() => setSelectingCustomers(true)}
            />
        </ButtonRow>
    </Search>
}

const Recipients = ({broadcast, selectCustomers, setSelectingCustomers}) => {
    if (!broadcast?.recipients?.length) {
        return <NoItems
            icon="Users"
            title="No customers"
            message="Select customers to send the broadcast to."
            onClick={() => setSelectingCustomers(true)}
        />
    }

    return <ul className="divide-y divide-gray-200">
        {broadcast.recipients.map((r, i) => {
            return <li key={r.id} className="gap-x-6 py-3 flex flex-row justify-between">
                <div className="shrink-0">
                    <RecipientStatus recipient={r} />
                </div>
                <div className="grow">
                    <p>
                        <Title customer={r.customer} />
                        <br />
                        <Subtitle className="text-muted" customer={r.customer} />
                    </p>
                </div>
                <div className="shrink-0 flex items-center">
                    <Dropdown options={[
                        {
                            title: 'View customer',
                            icon: 'User',
                            to: getEntityLink('Customers/Customer', r.customerId, {_back: window.location.pathname})
                        },
                    ]} />
                </div>
            </li>
        })}
    </ul>
}

export default Customers;